import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='footer-container'>
      <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
          Iveta Krempaská
        </p>
        <p className='footer-subscription-text'>
          krempaska21@uniba.sk
        </p>
      </section>

    </div>
  );
}

export default Footer;